import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountRequest, AuthService, Profile } from '../../../services/Auth/auth.service';
import { CsvDownloadComponent } from "../../UI/csv-download/csv-download.component";

@Component({
    selector: 'app-dashboard-deleted-accounts',
    imports: [
        CommonModule,
        RouterModule,
        CsvDownloadComponent
    ],
    templateUrl: './dashboard-deleted-accounts.component.html',
    styleUrl: './dashboard-deleted-accounts.component.scss'
})
export class DashboardDeletedAccountsComponent {
    public deletedList: Profile[] = []

    constructor(
        public authService: AuthService
    ) {
        this.authService.getDeletedProfiles().subscribe(data => {
            this.deletedList = data
        })
    }
}
